"use client";
import { Button } from "@/src/components/Button";
import { WebShopIcon } from "@/src/components/WebShopIcon";
import { IconButton, Modal, Stack, Typography } from "@mui/material";
import { FieldDetailInfoModalProps } from "../../lib/type";
import DOMPurify from "dompurify";

export const FieldDetailInfoModal: React.FC<FieldDetailInfoModalProps> = ({
  open,
  actions = [],
  title = "",
  description = "",
  onClose,
}) => {
  const sanitizedDescription = DOMPurify.sanitize(description);

  return (
    <Modal open={open} onClose={onClose}>
      <Stack className="flex max-h-[95%] w-full max-w-[524px] flex-col gap-6 overflow-auto rounded-xl bg-white p-6 px-0 pt-0 shadow-xl center-modal max-md:max-h-[70%] max-md:animate-up-modal max-md:bottom-modal">
        <Stack className="sticky top-0 w-full bg-inherit px-6 pt-6 flex-center-row">
          <Typography
            variant="h1"
            component="h3"
            className="flex-1 text-center text-2xl"
          >
            {/* {"Окремі питання"} */}
          </Typography>
          <IconButton onClick={onClose}>
            <WebShopIcon name="close" className="fill-blue" />
          </IconButton>
        </Stack>
        <Stack className="flex flex-col gap-2 px-6">
          <Typography
            component={"h4"}
            variant={"h4"}
            className="text-dark-gray"
          >
            {title}
          </Typography>
          <Typography variant={"body1"}>
            <div
              className="[&_ol]:list-decimal [&_ol]:pl-4 [&_ul]:list-disc [&_ul]:pl-4"
              dangerouslySetInnerHTML={{ __html: sanitizedDescription }}
            ></div>
          </Typography>
        </Stack>
        <Stack className="flex flex-col gap-3 px-6">
          {actions.map(({ title, variant, ...rest }, i) => (
            <Button variant={variant} {...rest} key={i}>
              {title}
            </Button>
          ))}
        </Stack>
      </Stack>
    </Modal>
  );
};
